import React from "react";
import { Logo, Elearning } from "../../assets/images";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import "./auth.css";
interface AuthLayoutComponentProps {
  title1?: string;
  title2?: string;
  title3?: string;
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutComponentProps> = ({
  title1,
  title2,
  title3,
  children,
}) => {
  const navigate = useNavigate();

  return (
    <div className="auth-container">
      {/* Animated Background */}
      <div className="auth-background">
        <div className="gradient-orb orb-1"></div>
        <div className="gradient-orb orb-2"></div>
        <div className="gradient-orb orb-3"></div>
      </div>

      <div className="auth-content">
        {/* Left Section */}
        <div className="auth-left-section">
          <div className="auth-left-content">
            <div className="logo-container">
              <img src={Logo} alt="Mascotte" className="auth-logo" />
            </div>

            <div className="auth-title-container">
              <h1 className="auth-main-title">
                {title1}
              </h1>
              <h2 className="auth-sub-title">
                {title2}
              </h2>
              <p className="auth-description">{title3}</p>
            </div>

            <div className="auth-illustration-container">
              <div className="illustration-glow"></div>
              <img
                src={Elearning}
                alt="Illustration"
                className="auth-illustration"
              />
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="auth-right-section">
          <div className="auth-form-card">
            {/* Back button */}
            <button 
              onClick={() => navigate("/")}
              className="absolute top-6 left-6 md:top-8 md:left-8 group flex items-center gap-2 text-text/30 hover:text-primary transition-all duration-300 z-[100]"
              title="Retour à l'accueil"
            >
              <div className="w-9 h-9 md:w-11 md:h-11 rounded-2xl bg-slate-50 border border-gray-100/50 flex items-center justify-center group-hover:bg-primary/10 group-hover:border-primary/20 group-hover:-translate-x-1 transition-all duration-300">
                <FontAwesomeIcon icon={faArrowLeft} className="text-[10px] md:text-sm" />
              </div>
              <span className="text-[9px] md:text-[10px] font-black uppercase tracking-[0.2em] opacity-0 group-hover:opacity-100 -translate-x-2 group-hover:translate-x-0 transition-all duration-300 hidden sm:inline-block">
                Retour
              </span>
            </button>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
